import transverser from '@/helpers/transverser'
import session from '@/auth/session'

export default (to, from, next) => {
  let userRoleAllowed = transverser.get('meta.userRoleAllowed', false)(to)
  if (!userRoleAllowed || userRoleAllowed.includes(session.getUserRole())) {
    return next()
  } else {
    return next({
      name: 'err'
    })
  }
}
